import React, { useEffect, useRef } from 'react';
import { useInViewport } from 'ahooks';
import { useLatest } from '../../utils/use-latest';
import { withNativeProps } from '../../utils/native-props';
export var LazyDetector = function LazyDetector(props) {
  var ref = useRef(null);

  var _useInViewport = useInViewport(ref),
      inViewport = _useInViewport[0];

  var onActive = useLatest(props.onActive);
  useEffect(function () {
    if (inViewport) {
      onActive.current();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inViewport]);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }));
};